import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_PETITION_STAFFING_TEAMS = defineFcm('petition_staffing_teams')
	.asJson(
		createShapeNormalizer({
			type: 'array',
			shape: { type: 'string' },
		}),
	)
	.withDefault([])
	.toConfig({
		owner: 'squad-site-platform',
		scope: 'corgi-front-end',
		supportedGroups: { global: true },
		context: 'Admin petition details — Team Staffing dropdown',
		description:
			'Allowed campaign team codes shown in the Team Staffing Petition dropdown on the admin petition details page.',
		import: false,
		template: [],
	});
